import CountDown from "@/components/ActivityBanner/countDown";
import { gdImgSrcPolicy } from "@/utils/imageUrl";
import { Button } from "antd";
import classNames from "classnames";
import { pick } from "lodash";
import { useState } from "react";
import HBModel from ".";
import Image from "../Image";
import ModalWrap from "./ModalWrap";
import styles from "./common.module.less";
const pickProps = (props) =>
  pick(props, [
    "type",
    "classname",
    "style",
    "danger",
    "shape",
    "icon",
    "size",
    "loading",
    "ghost",
    "block",
  ]);

function RawHBCommonDialog({
  module_name,
  imageUrl,
  description,
  title,
  plan_id,
  module_id,
  showOkBtn = true,
  okText,
  okButtonProps,
  showCancelBtn = true,
  cancelText,
  cancelButtonProps,
  onOk,
  onCancel,
  ...props
}) {
  return (
    <HBModel
      {...props}
      footer={null}
      title={null}
      maskClosable={false}
      onCancel={onCancel}
      width={400}
      className={classNames(styles.commonDialog, {
        [styles.hasImg]: !!imageUrl,
      })}
    >
      <div
        data-dialog-title={module_name || title}
        data-gd-expose="dialog_expose"
        data-plan-id={plan_id}
        data-create-id={module_id}
      >
        {imageUrl && (
          <Image
            alt="配图"
            width={400}
            height={164}
            {...gdImgSrcPolicy(imageUrl, {
              displayWidth: 400,
              aspectRatio: 164 / 400,
            })}
          />
        )}
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
        <div className={styles.footer}>
          {showCancelBtn && (
            <Button
              width="170"
              onClick={() => {
                onCancel && onCancel();
              }}
              data-gd-click="dialog_action"
              data-dialog-action={cancelText || "取消"}
              {...(pickProps(cancelButtonProps) || {})}
            >
              {cancelText || "取消"}
            </Button>
          )}
          {showOkBtn && (
            <Button
              width="170"
              onClick={() => {
                onOk && onOk();
              }}
              data-gd-click="dialog_action"
              data-dialog-action={okText || "确认"}
              {...(pickProps(okButtonProps) || {})}
            >
              {okText || "确认"}
            </Button>
          )}
        </div>
      </div>
    </HBModel>
  );
}

export const HBCommonDialog = ModalWrap(RawHBCommonDialog);

function RawHBImageDialog({
  module_name,
  imageUrl,
  onOk,
  countDown,
  plan_id,
  module_id,
  ...props
}) {
  const [showCountDown, setShowCountDown] = useState(
    countDown?.targetDate && new Date().getTime() < countDown?.targetDate * 1000
  );

  return (
    <HBModel
      {...props}
      footer={null}
      title={null}
      width={480}
      maskClosable={false}
      className={styles.imageDialog}
    >
      {imageUrl && (
        <Image
          alt="配图"
          width={480}
          {...gdImgSrcPolicy(imageUrl, {
            displayWidth: 480,
            sharpen: 80,
            type: "png",
          })}
          data-dialog-title={module_name}
          data-gd-expose="dialog_expose"
          data-plan-id={plan_id}
          data-create-id={module_id}
          onClick={onOk}
          data-gd-click="dialog_action"
          data-dialog-action="图片点击"
        />
      )}
      {showCountDown && (
        <CountDown
          className={styles.countDown}
          {...countDown}
          targetDate={
            countDown?.targetDate ? +countDown?.targetDate * 1000 : null
          }
          onEnd={() => {
            setShowCountDown(false);
          }}
        />
      )}
    </HBModel>
  );
}

export const HBImageDialog = ModalWrap(RawHBImageDialog);
